
import React from 'react';
import Dialog from '@mui/material/Dialog';

interface ImageViewerProps {
  open: boolean;
  imageSrc: string;
  onClose: () => void;
}

export default function ImageViewer({ open, imageSrc, onClose }: ImageViewerProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg">
      <img src={imageSrc} alt="Imagen" style={{ width: '100%', height: 'auto' }} />
    </Dialog>
  );
}